var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Map",
    transform: "translate(-27.000000, -793.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(27.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,707 C4.48,707 0,711.48 0,717 C0,722.52 4.48,727 10,727 C15.52,727 20,722.52 20,717 C20,711.48 15.52,707 10,707 Z M14,718 L11,718 L11,721 C11,721.55 10.55,722 10,722 C9.45,722 9,721.55 9,721 L9,718 L6,718 C5.45,718 5,717.55 5,717 C5,716.45 5.45,716 6,716 L9,716 L9,713 C9,712.45 9.45,712 10,712 C10.55,712 11,712.45 11,713 L11,716 L14,716 C14.55,716 15,716.45 15,717 C15,717.55 14.55,718 14,718 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add-white.6c3bbb1a4b3869c43d7faad4b23ded49.svg";
export { ForwardRef as ReactComponent };